import React, { useState } from "react";
import MapView from "./MapView";

const PRACTICES = [
  {
    id: "rotation",
    title: "Rotation culturale",
    description: "Alterner les cultures pour améliorer la fertilité, lutter contre les parasites et réduire les risques de maladies. Favorise la biodiversité et la résilience des sols.",
    avantages: ["Réduit les parasites", "Améliore la structure du sol", "Optimise la fertilité"],
    cultures: ["Maïs", "Blé", "Légumineuses", "Orge"]
  },
  {
    id: "engrais-vert",
    title: "Engrais vert",
    description: "Utiliser des légumineuses ou autres plantes pour enrichir le sol en azote et matière organique, améliorer la rétention d'eau et limiter l'érosion.",
    avantages: ["Apport d'azote naturel", "Augmente la matière organique", "Protège contre l'érosion"],
    cultures: ["Trèfle", "Luzerne", "Vesce"]
  },
  {
    id: "irrigation",
    title: "Irrigation ciblée",
    description: "Apporter l’eau au bon moment selon le stade de la culture et les conditions météo pour limiter le stress hydrique et optimiser le rendement.",
    avantages: ["Limite le stress hydrique", "Économise l'eau", "Améliore le rendement"],
    cultures: ["Maïs", "Pommes de terre", "Fruits"]
  },
];

const layers = [
  "Projet_MOS_Essai:BDPPAD_2015_MRC_MOS",
  "Projet_MOS_Essai:BDPPAD_2016_MRC_MOS",
  "Projet_MOS_Essai:BDPPAD_2017_MRC_MOS",
  "Projet_MOS_Essai:BDPPAD_2018_MRC_MOS",
  "Projet_MOS_Essai:BDPPAD_2019_MRC_MOS",
  "Projet_MOS_Essai:BDPPAD_2020_MRC_MOS",
  "Projet_MOS_Essai:BDPPAD_2021_MRC_MOS",
  "Projet_MOS_Essai:BDPPAD_2022_MRC_MOS",
  "Projet_MOS_Essai:BDPPAD_2023_MRC_MOS",
  "Projet_MOS_Essai:BDPPAD_2024_MRC_MOS"
];

export default function Pratiques({ onNavigate }) {
  const [selected, setSelected] = useState(null);
  const [activeLayer, setActiveLayer] = useState(layers[layers.length - 1]);
  const [visibleLayers, setVisibleLayers] = useState([layers[layers.length - 1]]);

  const handleLayerToggle = (layer) => {
    setVisibleLayers((prev) =>
      prev.includes(layer)
        ? prev.filter(l => l !== layer)
        : [...prev, layer]
    );
    setActiveLayer(layer);
  };

  return (
    <div style={{ width: "100vw", minHeight: "100vh", maxWidth: "none", margin: 0, padding: "3em 0", background: "#f6f8f5", borderRadius: 0, position: "relative", boxShadow: "none", color: "#232b21" }}>
      <div style={{ maxWidth: 1400, margin: "0 auto" }}>
        <button
          onClick={() => onNavigate && onNavigate("accueil")}
          style={{
            background: "#3a4a2a",
            color: "#e6e6d6",
            border: "none",
            borderRadius: 8,
            padding: "0.7em 1.5em",
            fontWeight: 600,
            fontSize: "1em",
            marginBottom: "1.5em",
            boxShadow: "0 1px 4px #0002",
            cursor: "pointer",
            alignSelf: "flex-start"
          }}
        >
          Retour à l'accueil
        </button>
        <h1 style={{ fontSize: "2em", fontWeight: "bold", color: "#232b21", marginBottom: "1em" }}>
          Pratiques agricoles
        </h1>
        <ul style={{ padding: 0, listStyle: "none", marginBottom: "2em" }}>
          {PRACTICES.map((p) => (
            <li key={p.id} style={{ marginBottom: "1em" }}>
              <button
                onClick={() => setSelected(p)}
                style={{
                  width: "100%",
                  textAlign: "left",
                  background: selected?.id === p.id ? "#dbead7" : "#fff",
                  border: "1px solid #b7cbb2",
                  borderRadius: "8px",
                  padding: "1em",
                  fontWeight: "bold",
                  fontSize: "1em",
                  cursor: "pointer",
                }}
              >
                {p.title}
              </button>
            </li>
          ))}
        </ul>
        <div style={{ minHeight: "80px", background: "#fff", borderRadius: "8px", padding: "1em", border: "1px solid #eee", marginBottom: "2em" }}>
          {selected ? (
            <>
              <h2 style={{ fontSize: "1.15em", marginBottom: "0.5em" }}>{selected.title}</h2>
              <p>{selected.description}</p>
              <ul style={{ paddingLeft: "1.2em", marginBottom: "0.5em" }}>
                {selected.avantages?.map((a, i) => (
                  <li key={i} style={{ color: "#166534", fontSize: "0.98em" }}>{a}</li>
                ))}
              </ul>
              <div style={{ fontSize: "0.95em", color: "#39433a" }}>
                <b>Exemples de cultures :</b> {selected.cultures?.join(", ")}
              </div>
            </>
          ) : (
            <p>Sélectionnez une pratique pour afficher son détail.</p>
          )}
        </div>
        <div style={{ marginTop: "2.5em", display: "flex", gap: "2em", alignItems: "flex-start" }}>
          <div style={{ minWidth: 260 }}>
            <h4 style={{ fontSize: "1em", marginBottom: "0.5em" }}>Couches BDPPAD par année</h4>
            <ul style={{ fontSize: "0.95em", paddingLeft: 0, listStyle: "none" }}>
              {layers.map(layer => (
                <li key={layer} style={{ marginBottom: "0.4em" }}>
                  <label style={{ display: "flex", alignItems: "center", gap: "0.5em" }}>
                    <input
                      type="checkbox"
                      checked={visibleLayers.includes(layer)}
                      onChange={() => handleLayerToggle(layer)}
                    />
                    <button
                      className={activeLayer === layer ? "active" : ""}
                      onClick={() => setActiveLayer(layer)}
                      style={{
                        marginLeft: "0.5em",
                        fontSize: "0.95em",
                        padding: "0.15em 0.7em",
                        background: activeLayer === layer ? "#b7cbb2" : "#e3e8e1",
                        border: "none",
                        borderRadius: "5px",
                        cursor: "pointer"
                      }}
                    >
                      {layer.split("_")[1]}
                    </button>
                  </label>
                </li>
              ))}
            </ul>
          </div>
          <div style={{ flex: 1, minWidth: 400, height: "650px", borderRadius: "12px", overflow: "hidden", boxShadow: "0 2px 8px #0001" }}>
            <MapView activeLayer={activeLayer} visibleLayers={visibleLayers} />
          </div>
        </div>
      </div>
    </div>
  );
}
